<div class="amount-field">
    <form [formGroup]="amountFormGroup">
        <div class="form-control-wrapper">
            <mat-form-field hideRequiredMarker>
                <mat-label>
                    {{ 'PARTY.CASHIER.web.common.amount.currency' | translate }}
                    {{ selectedOption()?.paymentMethodInfo?.minDepositLimit?.currencyCode ?? '' | vnCurrencySymbol }}
                </mat-label>
                <input
                    type="text"
                    id="userAmount"
                    name="userAmount"
                    formControlName="userAmount"
                    matInput
                    required
                    inputmode="decimal"
                    [(ngModel)]="depositInfo.amountInAccountCurrency"
                    step="0.01"
                    class="form-control"
                    [readonly]="depositRedirectService?.popupBlocked()"
                    (keypress)="keyPressNumbersDecimal($event)"
                    (input)="onChangeAmt()"
                    onpaste="return false;"
                    ondrop="return false;" />
                @let minLimit = selectedOption()?.paymentMethodInfo?.minDepositLimit?.value;
                @if (showAmountError) {
                    <mat-hint>
                        <span> {{ 'PARTY.CASHIER.web.common.min.label' | translate }}: {{ minLimit | vnCurrency }} </span>
                        @if (showMaxLimit) {
                            <span class="mx-1">|</span>
                            <span>{{ 'PARTY.CASHIER.web.common.max.label' | translate }}: {{ +maxDepositLimit | vnCurrency }} </span>
                        }
                    </mat-hint>
                }
                @let amountCtrl = amountFormGroup?.controls?.userAmount;
                @if (showAmountError && (amountCtrl?.dirty || amountCtrl?.touched)) {
                    <mat-error>
                        @if (amountCtrl?.errors?.required) {
                            <span>{{ 'PARTY.CASHIER.web.deposit.amount.required' | translate }}</span>
                        } @else if (amountCtrl?.errors?.pattern) {
                            <span>{{ 'PARTY.CASHIER.web.deposit.amount.invalid' | translate }}</span>
                        } @else if (amountCtrl?.errors?.providerBalance) {
                            <span>{{ 'PARTY.CASHIER.web.deposit.prepaidcard.accountbalance.error' | translate }}</span>
                        } @else if (
                            amountCtrl?.hasError('min') &&
                            !amountCtrl?.hasError('spainRekycLimit') &&
                            !amountCtrl?.hasError('spainAnnRekycLimitExceeded') &&
                            !amountCtrl?.hasError('expiredKycLimitValidation')
                        ) {
                            <span>
                                {{ 'PARTY.CASHIER.web.common.min.label' | translate }} :
                                {{ minLimit | vnCurrency }}
                            </span>
                        } @else if (
                            showMaxLimit &&
                            amountCtrl?.hasError('max') &&
                            !amountCtrl?.hasError('selfSetLimit') &&
                            !amountCtrl?.hasError('spainRekycLimit') &&
                            !amountCtrl?.hasError('spainAnnRekycLimitExceeded') &&
                            !amountCtrl?.hasError('expiredKycLimitValidation')
                        ) {
                            <span> {{ 'PARTY.CASHIER.web.common.max.label' | translate }} : {{ +maxDepositLimit | vnCurrency }} </span>
                        }
                    </mat-error>
                }
            </mat-form-field>
        </div>
    </form>
</div>
